// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__21pl9","savePackageButton":"ClientWallet_savePackageButton__2TECz"};